import { NextRouter } from "next/router";

import { RouteName } from "@/consts";
import { AnalyticsEventEnum } from "@/consts/AnalyticsEventEnum";

export const getUnfollowUserButtonEvent = (router: NextRouter) => {
  const { route } = router;

  switch (route) {
    case `${RouteName.ProfileUserRoute}`:
    case `${RouteName.ChannelRoute}`:
      return AnalyticsEventEnum.PublicProfileClickUnfollow;
    case RouteName.Home:
      return AnalyticsEventEnum.TopWriterClickUnfollow;
    default:
  }
};
